import { Link } from "react-router-dom"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


function Home() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        fade: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    };
    return (
        <>
            <>
                <section className="main-slider-three" id="home">
                    <Slider
                        {...settings}
                        className="main-slider-three__carousel eduhive-owl__carousel eduhive-owl__carousel--basic-nav owl-carousel owl-theme home-slider active"
                    >
                        <div className="main-slider-three__item">
                            <div className="main-slider-three__bg" style={{ backgroundImage: "url(/assets/images/main-slider-bg-2-1.png)" }}>
                            </div>
                            <div className="container">
                                <div className="row gutter-y-60 align-items-center">
                                    <div className="col-lg-12">
                                        <div className="main-slider-three__content">
                                            <div className="main-slider-three__video">
                                                <Link to="/" className="main-slider-three__video__btn video-btn video-popup">
                                                    <i className="icon-home"></i>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </Link>
                                            </div>
                                            <h3 className="main-slider-three__title">
                                                <span className="main-slider-three__title__inner">
                                                    <span
                                                        className="main-slider-three__title__text main-slider-three__title__text--1">
                                                        BО‘LAJAK TARBIYACHILARNI <br />
                                                        <span className="main-slider-three__title__highlight"> KASBIY METODIK KOMPETENSIYALARINI</span>
                                                    </span>
                                                </span>
                                                <span className="main-slider-three__title__inner">
                                                    <span
                                                        className="main-slider-three__title__text main-slider-three__title__text--2">
                                                        RIVOJLANTIRISH TEXNOLOGIYASI
                                                    </span>
                                                </span>
                                            </h3>
                                            <div className="main-slider-three__bottom">
                                                <div className="main-slider-three__bottom__inner">
                                                    <Link to="/experiments" className="main-slider-three__btn eduhive-btn">
                                                        <span className="eduhive-btn__text">Boshlash</span>
                                                        <span className="eduhive-btn__icon">
                                                            <span className="eduhive-btn__icon__inner"><i
                                                                className="icon-right-arrow"></i></span>
                                                        </span>
                                                    </Link>
                                                </div>
                                                <div className="main-slider-three__bottom__inner">
                                                    <div className="main-slider-three__student">
                                                        <div className="main-slider-three__student__image">
                                                            <img src="/assets/images/germany2_flag.jpg" alt="student" />
                                                            <img src="/assets/images/usa2_flag.jpg" alt="student" />
                                                            <img src="/assets/images/korea2_flag.jpg" alt="student" />
                                                            <img src="/assets/images/russia2_flag.jpg" alt="student" />
                                                            <h4 className="main-slider-three__student__count count-box">
                                                                <span className="count-text" data-stop="4"
                                                                    data-speed="1500">0</span><span>+</span>
                                                            </h4>
                                                        </div>
                                                        <p className="main-slider-three__student__text">tajribalar</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="main-slider-three__content__circle-one main-slider-three__circle"></div>
                                            <div className="main-slider-three__content__circle-two main-slider-three__circle"></div>
                                        </div>
                                        <div className="main-slider-three__images">
                                            <Link to="/experiment/russia" className="main-slider-three__image main-slider-three__image--top">
                                                <img src="/assets/images/russia_flag.jpg" alt="main-slider" className="slider-image" />
                                            </Link>
                                            <Link to="/experiment/usa" className="main-slider-three__image">
                                                <img src="/assets/images/usa_flag.png" alt="main-slider" className="slider-image" />
                                            </Link>
                                            <Link to="/experiment/korea" className="main-slider-three__image">
                                                <img src="/assets/images/korea_flag.png" alt="main-slider" className="slider-image" />
                                            </Link>
                                            <Link to="/experiment/germany" className="main-slider-three__image main-slider-three__image--top">
                                                <img src="/assets/images/germany_flag.png" alt="main-slider" className="slider-image" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img src="/assets/images/main-slider-shape-3-1.png" alt="shape"
                                className="main-slider-three__shape-one slider-image" />
                            <img src="/assets/images/main-slider-shape-3-2.png" alt="shape"
                                className="main-slider-three__shape-two slider-image" />
                            <div className="main-slider-three__box-one"></div>
                            <div className="main-slider-three__box-two"></div>
                            <div className="main-slider-three__circle-one main-slider-three__circle"></div>
                            <div className="main-slider-three__circle-two main-slider-three__circle"></div>
                            <div className="main-slider-three__circle-three main-slider-three__circle"></div>
                            <div className="main-slider-three__circle-four main-slider-three__circle"></div>
                        </div>
                        <div className="main-slider-three__item">
                            <div className="main-slider-three__bg" style={{ backgroundImage: "url(/assets/images/main-slider-bg-2-1.png)" }}>
                            </div>
                            <div className="container">
                                <div className="row gutter-y-60 align-items-center">
                                    <div className="col-lg-12">
                                        <div className="main-slider-three__content">
                                            <div className="main-slider-three__video">
                                                <Link to="/" className="main-slider-three__video__btn video-btn video-popup">
                                                    <i className="icon-home"></i>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </Link>
                                            </div>
                                            <h3 className="main-slider-three__title">
                                                <span className="main-slider-three__title__inner">
                                                    <span
                                                        className="main-slider-three__title__text main-slider-three__title__text--1">
                                                        BО‘LAJAK TARBIYACHILARNI <br />
                                                        <span className="main-slider-three__title__highlight"> KASBIY METODIK KOMPETENSIYALARINI</span>
                                                    </span>
                                                </span>
                                                <span className="main-slider-three__title__inner">
                                                    <span
                                                        className="main-slider-three__title__text main-slider-three__title__text--2">
                                                        RIVOJLANTIRISH TEXNOLOGIYASI
                                                    </span>
                                                </span>
                                            </h3>
                                            <div className="main-slider-three__bottom">
                                                <div className="main-slider-three__bottom__inner">
                                                    <Link to="/experiments" className="main-slider-three__btn eduhive-btn">
                                                        <span className="eduhive-btn__text">Boshlash</span>
                                                        <span className="eduhive-btn__icon">
                                                            <span className="eduhive-btn__icon__inner"><i
                                                                className="icon-right-arrow"></i></span>
                                                        </span>
                                                    </Link>
                                                </div>
                                                <div className="main-slider-three__bottom__inner">
                                                    <div className="main-slider-three__student">
                                                        <div className="main-slider-three__student__image">
                                                            <img src="/assets/images/germany2_flag.jpg" alt="student" />
                                                            <img src="/assets/images/usa2_flag.jpg" alt="student" />
                                                            <img src="/assets/images/korea2_flag.jpg" alt="student" />
                                                            <img src="/assets/images/russia2_flag.jpg" alt="student" />
                                                            <h4 className="main-slider-three__student__count count-box">
                                                                <span className="count-text" data-stop="4"
                                                                    data-speed="1500">0</span><span>+</span>
                                                            </h4>
                                                        </div>
                                                        <p className="main-slider-three__student__text">tajribalar</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="main-slider-three__content__circle-one main-slider-three__circle"></div>
                                            <div className="main-slider-three__content__circle-two main-slider-three__circle"></div>
                                        </div>
                                        <div className="main-slider-three__images">
                                            <Link to="/experiment/russia" className="main-slider-three__image main-slider-three__image--top">
                                                <img src="/assets/images/russia_flag.jpg" alt="main-slider" className="slider-image" />
                                            </Link>
                                            <Link to="/experiment/usa" className="main-slider-three__image">
                                                <img src="/assets/images/usa_flag.png" alt="main-slider" className="slider-image" />
                                            </Link>
                                            <Link to="/experiment/usa" className="main-slider-three__image">
                                                <img src="/assets/images/korea_flag.png" alt="main-slider" className="slider-image" />
                                            </Link>
                                            <Link to="/experiment/germany" className="main-slider-three__image main-slider-three__image--top">
                                                <img src="/assets/images/germany_flag.png" alt="main-slider" className="slider-image" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img src="/assets/images/main-slider-shape-3-1.png" alt="shape"
                                className="main-slider-three__shape-one slider-image" />
                            <img src="/assets/images/main-slider-shape-3-2.png" alt="shape"
                                className="main-slider-three__shape-two slider-image" />
                            <div className="main-slider-three__box-one"></div>
                            <div className="main-slider-three__box-two"></div>
                            <div className="main-slider-three__circle-one main-slider-three__circle"></div>
                            <div className="main-slider-three__circle-two main-slider-three__circle"></div>
                            <div className="main-slider-three__circle-three main-slider-three__circle"></div>
                            <div className="main-slider-three__circle-four main-slider-three__circle"></div>
                        </div>
                    </Slider>
                </section>
                <section className="course-category course-category--home-3 section-space-bottom">
                    <div className="container">
                        <div className="row gutter-y-30">
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="00ms">
                                <div className="course-category__card course-category__card--1">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--secondary">
                                            <span className="course-category__card__icon">
                                                <i className="icon-briefcase"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Kasbiy o‘sish  <br /> muhiti</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="100ms">
                                <div className="course-category__card course-category__card--2">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--pink">
                                            <span className="course-category__card__icon">
                                                <i className="icon-art-studies"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Metodik   <br /> yondashuvlar</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="200ms">
                                <div className="course-category__card course-category__card--3">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--secondary">
                                            <span className="course-category__card__icon">
                                                <i className="icon-self-confidence"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Interaktiv kasbiy   <br /> rivojlanish</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="300ms">
                                <div className="course-category__card course-category__card--4">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--yellow2">
                                            <span className="course-category__card__icon">
                                                <i className="icon-setting"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Nazariy va amaliy  <br /> uyg‘unlik</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="00ms">
                                <div className="course-category__card course-category__card--5">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--base">
                                            <span className="course-category__card__icon">
                                                <i className="icon-healthcare"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Kasbiy  <br /> kompetensiya</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="100ms">
                                <div className="course-category__card course-category__card--6">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--primary">
                                            <span className="course-category__card__icon">
                                                <i className="icon-coding-1"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Amaliy o‘rgatuvchi  <br /> muhit</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="200ms">
                                <div className="course-category__card course-category__card--7">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--blue">
                                            <span className="course-category__card__icon">
                                                <i className="icon-clapperboard"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Raqamli  <br /> treninglar</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="300ms">
                                <div className="course-category__card course-category__card--8">
                                    <div className="course-category__card__content">
                                        <div className="course-category__card__icon-box course-category__card__icon-box--red">
                                            <span className="course-category__card__icon">
                                                <i className="icon-megaphone"></i>
                                            </span>
                                        </div>
                                        <h4 className="course-category__card__title">Tarbiyachi  <br /> tayyorgarligi</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="about-three" id="about">
                    <div className="container-fluid">
                        <div className="about-three__inner section-space">
                            <div className="container">
                                <div className="row gutter-y-50 align-items-center">
                                    <div className="col-lg-6 wow fadeInLeft" data-wow-duration="1500ms">
                                        <div className="about-three__image">
                                            <div className="about-three__image__inner">
                                                <img src="/assets/images/xalqaro_tajriba.jpg" alt="about" />
                                                <div className="about-three__experience">
                                                    <span className="about-three__experience__icon">
                                                        <i className="icon-connectibity"></i>
                                                    </span>
                                                    <div className="about-three__experience__content">
                                                        <h3 className="about-three__experience__title">4+</h3>
                                                        <p className="about-three__experience__text">Xorijiy tajribalar</p>
                                                    </div>
                                                </div>
                                                <div className="total-student">
                                                    <div className="total-student__inner">
                                                        <div className="total-student__image">
                                                            <img src="/assets/images/task.jpg" alt="student"
                                                                className="slider-image" />
                                                            <img src="/assets/images/method.jpg" alt="student"
                                                                className="slider-image" />
                                                        </div>
                                                        <h4 className="total-student__text count-box">
                                                            <span className="count-text" data-stop="200"
                                                                data-speed="1500">4</span><span>+ <br /> Topshiriqlar</span>
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="about-three__image__shape-one"></div>
                                                <div className="about-three__image__shape-two"></div>
                                            </div>
                                            <div className="about-three__image__box"></div>
                                            <img src="/assets/images/about-shape-3-2.png" alt="shape"
                                                className="about-three__image__shape-three" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="about-three__content">
                                            <div className="sec-title wow fadeInUp" data-wow-duration="1500ms"
                                                data-wow-delay="00ms">
                                                <h6 className="sec-title__tagline">Loyiha haqida</h6>
                                                <h3 className="sec-title__title">BО‘LAJAK TARBIYACHILARNI <span
                                                    className="sec-title__title__text">KASBIY METODIK  </span> KOMPETENSIYALARINI <span
                                                        className="sec-title__title__shape">RIVOJLANTIRISH TEXNOLOGIYASI</span></h3>
                                            </div>
                                            <div className="about-three__description wow fadeInUp" data-wow-duration="1500ms"
                                                data-wow-delay="00ms">
                                                <p className="about-three__text">
                                                    Bo‘lajak tarbiyachilarning kasbiy-metodik bilim, ko‘nikma va malakalarini shakllantirish hamda rivojlantirishga yo‘naltirilgan innovatsion, interaktiv va amaliy mashg‘ulotlarga asoslangan raqamli o‘quv platformasi.
                                                </p>
                                            </div>
                                            <div className="about-three__content__inner">
                                                <div className="row gutter-y-30">
                                                    <div className="col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                                        data-wow-delay="00ms">
                                                        <div className="about-three__info">
                                                            <h3 className="about-three__info__title">Xorijiy tajribalar</h3>
                                                            <p className="about-three__info__text">Rivojlangan 4 ta davlat ta'lim tajribalari kiritilgan.</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                                                        data-wow-delay="100ms">
                                                        <div className="about-three__info">
                                                            <h3 className="about-three__info__title">Zamonaviy metodlar</h3>
                                                            <p className="about-three__info__text">Bugungi kundagi dars jarayonini samarali tashkil qilish metodlari.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="about-three__bottom wow fadeInUp" data-wow-duration="1500ms">
                                                <Link to="/experiments" className="eduhive-btn">
                                                    <span>O'rganish</span>
                                                    <span className="eduhive-btn__icon">
                                                        <span className="eduhive-btn__icon__inner"><i
                                                            className="icon-right-arrow"></i></span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img src="/assets/images/about-shape-3-1.png" alt="shape" className="about-three__shape-one" />
                            <div className="about-three__circle-one"></div>
                            <div className="about-three__circle-two"></div>
                            <div className="about-three__circle-three"></div>
                        </div>
                    </div>
                    <img src="/assets/images/about-shape-3-3.png" alt="shape" className="about-three__shape-two" />
                </section>

                <section className="funfact-one funfact-one--home-3 funfact-one--round">
                    <div className="container">
                        <div className="funfact-one__grid">
                            <div className="funfact-one__item funfact-one__item--secondary wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="00ms">
                                <div className="funfact-one__icon">
                                    <span className="funfact-one__icon__inner"><i className="icon-connectibity"></i></span>
                                </div>
                                <h3 className="funfact-one__title count-box">
                                    <span className="count-text" data-stop="5" data-speed="1500">5</span>
                                    <span>+</span>
                                </h3>
                                <p className="funfact-one__text">Tajribalar</p>
                            </div>
                            <div className="funfact-one__item funfact-one__item--primary wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="100ms">
                                <div className="funfact-one__icon">
                                    <span className="funfact-one__icon__inner"><i className="icon-batch-assign"></i></span>
                                </div>
                                <h3 className="funfact-one__title count-box">
                                    <span className="count-text" data-stop="6500" data-speed="1500">10</span>
                                    <span>+</span>
                                </h3>
                                <p className="funfact-one__text">Metodlar</p>
                            </div>
                            <div className="funfact-one__item funfact-one__item--secondary wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="200ms">
                                <div className="funfact-one__icon">
                                    <span className="funfact-one__icon__inner"><i className="icon-students"></i></span>
                                </div>
                                <h3 className="funfact-one__title count-box">
                                    <span className="count-text" data-stop="20" data-speed="1500">20</span>
                                    <span>+</span>
                                </h3>
                                <p className="funfact-one__text">Mashg'ulotlar</p>
                            </div>
                            <div className="funfact-one__item funfact-one__item--primary wow fadeInUp" data-wow-duration="1500ms"
                                data-wow-delay="300ms">
                                <div className="funfact-one__icon">
                                    <span className="funfact-one__icon__inner"><i className="icon-check-2"></i></span>
                                </div>
                                <h3 className="funfact-one__title count-box">
                                    <span className="count-text" data-stop="60" data-speed="1500">60</span>
                                    <span>+</span>
                                </h3>
                                <p className="funfact-one__text">Testlar</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="offer-one section-space-top">
                    <div className="container">
                        <div className="row gutter-y-60">
                            <div className="col-lg-6 wow fadeInUp" data-wow-duration="1500ms">
                                <div className="offer-one__image">
                                    <img src="/assets/images/offer-1-1.jpg" alt="offer" className="offer-one__image__one" />
                                    <img src="/assets/images/offer-1-2.jpg" alt="offer" className="offer-one__image__two" />
                                    <img src="/assets/images/offer-shape-1-1.png" alt="offer shape" className="offer-one__image__shape" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="offer-one__content">
                                    <div className="sec-title wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                                        <h3 className="sec-title__title"><span className="sec-title__title__shape">Platforma</span>
                                            <span className="sec-title__title__text"> imkoniyatlari</span> haqida
                                        </h3>
                                    </div>
                                    <div className="offer-one__inner">
                                        <div className="offer-one__item wow fadeInUp" data-wow-duration="1500ms">
                                            <div className="offer-one__item__icon offer-one__item__icon--primary">
                                                <i className="icon-instructors"></i>
                                            </div>
                                            <div className="offer-one__item__content">
                                                <h4 className="offer-one__item__title">Zamonaviy tarbiyachi</h4>
                                                <p className="offer-one__item__text">
                                                    Zamonaviy tarbiyachi bo'lish uchun zarur bo'lgan bilim va ko'nikmalarni o'z ichiga olgan innovatsion platforma.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="offer-one__item wow fadeInUp" data-wow-duration="1500ms">
                                            <div className="offer-one__item__icon offer-one__item__icon--secondary">
                                                <i className="icon-copy-writing"></i>
                                            </div>
                                            <div className="offer-one__item__content">
                                                <h4 className="offer-one__item__title">Zamonaviy metodlar</h4>
                                                <p className="offer-one__item__text">
                                                    Zamonaviy dars jarayonini tashkil qilish uchun zarur bo'lgan metod va texnologiyalar.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="offer-one__item wow fadeInUp" data-wow-duration="1500ms">
                                            <div className="offer-one__item__icon offer-one__item__icon--base">
                                                <i className="icon-community"></i>
                                            </div>
                                            <div className="offer-one__item__content">
                                                <h4 className="offer-one__item__title">Xalqaro tajriba almashish</h4>
                                                <p className="offer-one__item__text">
                                                    Xorijiy tajribalar bilan tanishish va ularni o'z amaliyotingizda qo'llash imkoniyati.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="/assets/images/offer-shape-1-3.png" alt="shape" className="offer-one__shape" />
                    <div className="offer-one__shape-box"></div>
                </section>
            </ >

        </>
    )
}

export default Home